import React, { useState } from 'react';
import './FontColourInput.scss';
import { RgbaColor, RgbaColorPicker } from 'react-colorful';
import { useDebouncedCallback } from 'use-debounce';
import useProject from '../../../hooks/useProject';
import { useTranslation } from 'react-i18next';
import { isRgbaColor, stringToRgaColor, toTwoDigitHex } from '../../../helpers/colorHelper/colorHelper';
import Help from '../../Help/Help';

const FontColourInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const deboucne = 500;

  const debouncedRgbaColorChange = useDebouncedCallback(
    (color: RgbaColor | string) => {
      let value = '';
      let transparency;

      if (isRgbaColor(color)) {
        value = `#${toTwoDigitHex(color.r)}${toTwoDigitHex(color.g)}${toTwoDigitHex(color.b)}`;
        transparency = color.a;
      } else {
        value = color;
        transparency = 0.75;
      }

      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayFontColour: value,
          overlayFontTransparency: transparency,
        });
      } else {
        updateEncoder(project.encoder, {
          overlayFontColour: value,
          overlayFontTransparency: transparency,
        });
      }
    },

    deboucne,
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rgbaColor, setRgbaColor] = useState(
    stringToRgaColor(project.encoder.overlayFontColour, project.encoder.overlayFontTransparency),
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fontColor, setFontColor] = useState(project.encoder.overlayFontColour || '#FFFFFF');

  return (
    <div className="font-colour-input">
      <div className="input-title">
        {t('producer.inputs.font-colour.title')}
        <Help
          title="Font Colour"
          text="Choose the colour you want your text to appear.<br/><br/>High contrast captions are the most accessible. The standard font choice captions is white or yellow text with a black or dark background."
        />
      </div>
      <RgbaColorPicker color={rgbaColor} onChange={debouncedRgbaColorChange} />
    </div>
  );
};

export default React.memo(FontColourInput);
